<template>
  <div
    @click="click"
    class="button-more"
  >
    <div
      class="button-more-text"
      :class="disabled ? 'button-more-disabled' : ''"
    >{{isFull ? closeText : moreText}}</div>
    <div
      class="button-more-arrow"
      :class="disabled ? 'button-more-disabled' : ''"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    isFull: {
      type: Boolean,
      default: false
    },
    moreText: { // false
      type: String,
      default: '展开'
    },
    closeText: { // true
      type: String,
      default: '收起'
    }
  },
  methods: {
    click () {
      if (this.disabled) {
        return
      }
      this.$emit('click')
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "var.css";
.button-more {
  color: var(--colorMain);
  display: inline-block;
  cursor: pointer;

  & .button-more-text {
    display: inherit;
  }
  & .button-more-arrow {
    display: inherit;
    width: 11px;
    height: 6px;
    background-image: url('https://az.cdn.nutsbp.com/007/image/nuts_dartcome/pc/pr/cut_page/pr_arrow_answer_open.png')
  }

  &:hover {}
  &:active {}
  &:disabled {}
  & .button-more-disabled {
    cursor: not-allowed;
    color: var(--colorDisabled);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/button/MoreButton.vue